var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('data-table',{attrs:{"headers":_vm.headers,"fields":_vm.fields,"items":_vm.followUps,"loading":_vm.loading,"sort":"created_at","title":"Follow Ups"}},[_vm._v("\n    >\n  ")]):_vm._e()],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63ead43d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/person/guest-cards/FollowUps.vue
// module id = sCoA
// module chunks = 0 1